

exports.__esModule = true;
exports.$loader = undefined;

var _event = require('./event');

var _firstLoad = false;

var loader = _event.$event.compose('loading', 'loaded', 'startLoad', 'allLoaded', 100);

var $loader = exports.$loader = {

    isLoading: function isLoading() {
        return Boolean(loader.getCount());
    },
    firstLoad: function firstLoad() {
        return _firstLoad;
    },
    reset: function reset() {
        loader.reset();
    }
};

_event.$event.on('allLoaded', function () {
    _firstLoad = true;
});

angular.value("$loader", $loader);
_event.$event;


//////////////////
// WEBPACK FOOTER
// ./components/squid/dist/core/loader.js
// module id = ./components/squid/dist/core/loader.js
// module chunks = 1